import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { Select as SENDER_SELECT } from 'Components/Api/InstantPayDMTApi';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { Container, Grid, Paper, Hidden } from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID,
    MONEY_TRANSFER_CODE
} from 'Components/Helper/Messages';
import BeneficiaryList from './BeneficiaryList';
import { Last10Report } from 'Pages/InnerPages/Report/Last10Report';
import { useLocation } from 'react-router-dom';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import AddbeneficiaryIcon from 'Components/SvgButtons/AddbeneficiaryIcon';
import AutoSubmitMobileForSender from 'Components/Helper/AutoSubmitMobileForSender';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const SenderSearch = ({ ActiveDMTName }) => {
    const formRef = useRef();
    const classes = commonStyle();
    const location = useLocation();
    const history = useHistory();
    const [senderNo, setSenderNo] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [addBeneficiary, setAddBeneficiary] = useState('none');
    const [serviceCode, setServiceCode] = useState(MONEY_TRANSFER_CODE);
    const Mobile = location?.state?.Mobile;
    const [formObject, setFormObject] = useState({
        Mobile: '',
        Name: '',
        SenderID: '',
        RemainingLimit: '',
        Consumed: '',
        isAddBeneficiary: false
    });

    useEffect(() => {
        select();
        fetchSender();
        setLoading(false);
    }, []);

    const fetchSender = () => {
        if (formRef === undefined) return;

        if (!formRef.current) return;

        if (formRef.current.values === undefined) return;

        if (formRef.current.values.Mobile === undefined) return;

        if (formRef.current.values.Mobile.length !== 10) return;

        formRef.current.handleSubmit();
    };

    const select = async () => {
        setLoading(true);
        let primaryID = Mobile;

        setLoading(false);

        if (primaryID === undefined) return;
        if (primaryID === null) return;

        if (primaryID === 'DMT') return;

        if (primaryID.length !== 10) return;

        setFormObject({
            ...formObject,
            Mobile: primaryID,
            Name: '',
            SenderID: '',
            RemainingLimit: ''
        });
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setFormObject({
            ...formObject,
            Mobile: values.Mobile,
            Name: '',
            SenderID: '',
            Consumed: '',
            RemainingLimit: ''
        });
        setServiceCode('');
        setSenderNo('');
        var requestObj = JSON.stringify(values);

        setLoading(true);
        setIsError(false);

        if (values.isAddBeneficiary) {
            let param = {
                Mobile: values.Mobile,
                SenderID: values.SenderID,
                SenderName: values.Name
            };
            history.push('/I_BeneficiaryAdd', param);
            return;
        }

        var response = await SENDER_SELECT(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setServiceCode(MONEY_TRANSFER_CODE);
        setSeverity('success');

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            if (response.data === 'Remitter Not Found') {
                let param = {
                    Mobile: values.Mobile
                };
                setResponseMessage(response.data);
                history.push('/I_SenderAdd', param);
                return;
            }

            setLoading(false);
            return;
        }
        setLoading(false);
        var data = JSON.parse(response.data);

        if (data.Message === 'Sender Not Verified') {
            setResponseMessage(data.Message);
            var param = {
                Mobile: values.Mobile,
                SenderID: values.SenderID
            };
            history.push('/I_SenderVerify', param);
        }

        if (
            data.Message ===
            'Your KYC is not approved, please contact to customer care'
        ) {
            history.push('/KYC/Upload');
            return;
        }

        setAddBeneficiary('inline');

        setFormObject({
            Mobile: data.Mobile,
            Name: data.Name,
            SenderID: data.SenderID,
            Consumed: data.Consumed,
            RemainingLimit: data.RemainingLimit,
            isAddBeneficiary: false
        });

        setSenderNo(data.Mobile);
        setLoading(false);
    };

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {({ setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <AutoSubmitMobileForSender />
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialNumberField
                                                label="Mobile"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                placeholder="Mobile"
                                                typed_length={1}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                title="Search"
                                                disabled={loading}
                                                endIcon={<SearchIcon />}
                                                onClick={(e) => {
                                                    setFieldValue(
                                                        'isAddBeneficiary',
                                                        false
                                                    );
                                                    setAddBeneficiary('none');
                                                    handleSubmit(e);
                                                }}
                                            >
                                                Search
                                            </PrimaryButton>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <Box display={addBeneficiary}>
                                                <PrimaryButton
                                                    title="Add Beneficiary"
                                                    disabled={loading}
                                                    endIcon={
                                                        <AddbeneficiaryIcon />
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddBeneficiary',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                >
                                                    Add Beneficiary
                                                </PrimaryButton>
                                            </Box>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        ></Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Name"
                                                name="Name"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Name"
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Remaining Limit"
                                                name="RemainingLimit"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Remaining Limit"
                                            />
                                            <Hidden xsUp>
                                                <MaterialTextField
                                                    label="SenderID"
                                                    name="SenderID"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="SenderID"
                                                />
                                            </Hidden>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Consumed"
                                                name="Consumed"
                                                type="text"
                                                readOnly={true}
                                                placeholder="Consumed"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            <BeneficiaryList
                senderNo={senderNo}
                ActiveDMTName={ActiveDMTName}
                senderName={formObject.Name}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />

            <Last10Report
                ServiceID={serviceCode}
                setIsError={(value) => {
                    setIsError(value);
                }}
                setSeverity={(value) => {
                    setSeverity(value);
                }}
                setLoading={(value) => {
                    setLoading(value);
                }}
                setResponseMessage={(value) => {
                    setResponseMessage(value);
                }}
                formRef={formRef}
            />
        </CustomContainer>
    );
};
